export const RESET_EDITPROFILE = "RESET_EDITPROFILE";
export const RESET_ERROR = "RESET_ERROR";
export const API_ERROR = "API_ERROR";
export const GET_EDITPROFILE = "GET_EDITPROFILE";
export const SET_EDITPROFILE = "SET_EDITPROFILE";
export const EDIT_EDITPROFILE = "EDIT_EDITPROFILE";
export const EDIT_EDITPROFILE_SUCCESS = "EDIT_EDITPROFILE_SUCCESS";
